import create from 'zustand';

type ReviewPanelStore = {
  isOpen: boolean;
  // Websocket id of the run in flight, per journey. Only an accelerator (the poll
  // is authoritative), but held here so it survives the panel unmounting.
  runWebsocketIdByJourney: Record<string, string>;
  // Signature key of the finding sent to the Navigator, per journey. Cleared when
  // the Navigator session stops generating; held here so it survives the panel unmounting.
  fixRequestByJourney: Record<string, string>;
  open: () => void;
  close: () => void;
  toggle: () => void;
  setRunWebsocketId: (journeyShortId: string, websocketId: string) => void;
  clearRunWebsocketId: (journeyShortId: string) => void;
  startExternalRun: (journeyShortId: string, websocketId: string) => void;
  setFixRequest: (journeyShortId: string, signatureKey: string) => void;
  clearFixRequest: (journeyShortId: string) => void;
};

export const useReviewPanelStore = create<ReviewPanelStore>((set) => ({
  isOpen: false,
  runWebsocketIdByJourney: {},
  fixRequestByJourney: {},
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set((state) => ({ isOpen: !state.isOpen })),
  setRunWebsocketId: (journeyShortId, websocketId) =>
    set((state) => ({
      runWebsocketIdByJourney: {
        ...state.runWebsocketIdByJourney,
        [journeyShortId]: websocketId,
      },
    })),
  clearRunWebsocketId: (journeyShortId) =>
    set((state) => {
      if (!(journeyShortId in state.runWebsocketIdByJourney)) return state;
      const next = { ...state.runWebsocketIdByJourney };
      delete next[journeyShortId];
      return { runWebsocketIdByJourney: next };
    }),
  startExternalRun: (journeyShortId, websocketId) =>
    set((state) => ({
      isOpen: true,
      runWebsocketIdByJourney: {
        ...state.runWebsocketIdByJourney,
        [journeyShortId]: websocketId,
      },
    })),
  setFixRequest: (journeyShortId, signatureKey) =>
    set((state) => ({
      fixRequestByJourney: { ...state.fixRequestByJourney, [journeyShortId]: signatureKey },
    })),
  clearFixRequest: (journeyShortId) =>
    set((state) => {
      if (!(journeyShortId in state.fixRequestByJourney)) return state;
      const next = { ...state.fixRequestByJourney };
      delete next[journeyShortId];
      return { fixRequestByJourney: next };
    }),
}));
